import * as React from "react";
import type { SVGProps } from "react";

interface HandCoinProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean;
}

const ACTIVE_COLOR = "#002A73";
const INACTIVE_COLOR = "#CECECE";

const HandCoin = ({ isActive = false, stroke, width, height, ...props }: HandCoinProps) => {
  const currentStroke = isActive ? ACTIVE_COLOR : stroke || INACTIVE_COLOR;

  // Optional: create a highlight behind the main hand/coin area
  // We'll use the main shape for the highlight, like in your other icons
  const highlightD =
    "M13.25 17.5H16.75L24.0781 15.8145C24.3475 15.7407 24.6304 15.73 24.9046 15.7833C25.1788 15.8365 25.4371 15.9523 25.6593 16.1216C25.8815 16.2909 26.0617 16.5091 26.1858 16.7594C26.3099 17.0097 26.3747 17.2852 26.375 17.5645C26.3751 17.9018 26.2813 18.2325 26.1039 18.5194C25.9265 18.8063 25.6727 19.0381 25.3709 19.1888L21.125 21L14.125 22.75H6.25V16.625L8.98438 13.8906C9.22878 13.6471 9.5188 13.4541 9.83784 13.3227C10.1569 13.1913 10.4987 13.1242 10.8438 13.125H16.3125C16.8927 13.125 17.4491 13.3555 17.8593 13.7657C18.2695 14.1759 18.5 14.7323 18.5 15.3125C18.5 15.8927 18.2695 16.4491 17.8593 16.8593C17.4491 17.2695 16.8927 17.5 16.3125 17.5H13.25Z";

  return (
    <svg
      {...props}
      width={width ?? "29"}
      height={height ?? "28"}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {isActive && <path opacity="0.2" d={highlightD} fill={ACTIVE_COLOR} />}
      <path
        d="M23.3125 12.25C25.0039 12.25 26.375 10.8789 26.375 9.1875C26.375 7.49613 25.0039 6.125 23.3125 6.125C21.6211 6.125 20.25 7.49613 20.25 9.1875C20.25 10.8789 21.6211 12.25 23.3125 12.25Z"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 22.75H2.75C2.51794 22.75 2.29538 22.6578 2.13128 22.4937C1.96719 22.3296 1.875 22.1071 1.875 21.875V17.5C1.875 17.2679 1.96719 17.0454 2.13128 16.8813C2.29538 16.7172 2.51794 16.625 2.75 16.625H6.25"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.25 17.5H16.75L24.0781 15.8145C24.3475 15.7407 24.6304 15.73 24.9046 15.7833C25.1788 15.8365 25.4371 15.9523 25.6593 16.1216C25.8815 16.2909 26.0617 16.5091 26.1858 16.7594C26.3099 17.0097 26.3747 17.2852 26.375 17.5645C26.3751 17.9018 26.2813 18.2325 26.1039 18.5194C25.9265 18.8063 25.6727 19.0381 25.3709 19.1888L21.125 21L14.125 22.75H6.25V16.625L8.98438 13.8906C9.22878 13.6471 9.5188 13.4541 9.83784 13.3227C10.1569 13.1913 10.4987 13.1242 10.8438 13.125H16.3125C16.8927 13.125 17.4491 13.3555 17.8593 13.7657C18.2695 14.1759 18.5 14.7323 18.5 15.3125C18.5 15.8927 18.2695 16.4491 17.8593 16.8593C17.4491 17.2695 16.8927 17.5 16.3125 17.5H13.25Z"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2498 9.32903C19.6554 9.61014 18.9863 9.6925 18.3415 9.56391C17.6967 9.43533 17.1104 9.10263 16.6693 8.61503C16.2282 8.12743 15.9558 7.51082 15.8923 6.85638C15.8287 6.20195 15.9775 5.54445 16.3166 4.98113C16.6557 4.41781 17.1671 3.97858 17.7752 3.7284C18.3832 3.47822 19.0556 3.43038 19.693 3.59195C20.3303 3.75352 20.8988 4.11593 21.3142 4.62556C21.7296 5.1352 21.97 5.76501 21.9998 6.42184"
        stroke={currentStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default HandCoin;
